import { render, staticRenderFns } from "./SidebarResp.vue?vue&type=template&id=161f0604"
import script from "./SidebarResp.vue?vue&type=script&lang=js"
export * from "./SidebarResp.vue?vue&type=script&lang=js"
import style0 from "./SidebarResp.vue?vue&type=style&index=0&id=161f0604&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports